import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';
import { ModalService } from 'src/app/_services/modal.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { API_URL, SUBMISSION_URL } from 'src/app/_common/constants';
import { map } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { NewBusinessService } from '../../new-business/_services/new-business.service';

@Injectable({
  providedIn: 'root'
})
export class SubmissionsService {

  private _submission;
  private _selectedStep: string; //Using it in HTML
  private _selectedNiche: any;
  private _selectedProducer: any;

  private supportingDocuments = [];

  constructor(private http: HttpClient, private newBusinessService: NewBusinessService, private commonService: CommonService, private modalService: ModalService) { }

  set header(data){
    this.commonService.header = data;
  }
  
  get runningServices(){
    return this.commonService.runningServices;
  }

  openModal(modalType, modalName, isKeyboard = true, backdropClass: string = '', isBackdrop?: boolean | 'static', customWindowClass='', size ="", _centered=true) {
    if(modalType === 'error'){
      this.modalService.openErrorModal();
    } else {
      this.modalService.openModal(modalName, isKeyboard, backdropClass, isBackdrop, customWindowClass, size, _centered);
    }
  }

  closeModal() {
    this.modalService.closeModal();
  }

  hasOpenModals() {
    return this.modalService.hasOpenModals();
  }


  getSubmissionData(){
    let psiData = this.commonService.getData();
    return psiData.submission;
  }  

  storeSubmissionData(_submission){
    let psiData = this.commonService.getData();
    psiData.submission = _submission;
    this.commonService.storeData(psiData);
  }

  set selectedNiche(_selectedNiche){
    this._selectedNiche = _selectedNiche;
  }
  get selectedNiche(){
    return this._selectedNiche;
  }
  set selectedProducer(_selectedProducer){
    this._selectedProducer = _selectedProducer;
  }
  get selectedProducer(){
    return this._selectedProducer;
  }
  
  get submission(){
    if(!this._submission){
      this._submission= this.getSubmissionData();
    }
    return this._submission;
  }
  set submission(_submission){
    this._submission = _submission;
    this.storeSubmissionData(_submission);
  }
  get selectedStep():string{
    if(!this._submission){
      this._submission = this.getSubmissionData();
    }
    return this._submission.selectedStep;
  }
  set selectedStep(_step){
    this._submission.selectedStep = _step;
    this._selectedStep = _step;
    this.storeSubmissionData(this._submission);
  }

  get referenceData(): any{
    return this.commonService.referenceData;
  }

  set referenceData(_data){
    this.commonService.referenceData = _data;
  }

  set loading(_loading){
    this.newBusinessService.loading = _loading;
  }
  get loading():boolean{
    return this.newBusinessService.loading;
  }

  
  getLoggedInProfile(){
    return this.commonService.getData().currentUser;
  }

  addSupportingDocument(_document){
    this.commonService.addSupportingDocument(_document);
  }
  getSupportingDocuments(){
    return this.commonService.getSupportingDocuments();
  }
  resetSupportingDocuments(){
    return this.commonService.resetSupportingDocuments();
  }

  //Fetch Reference (Lookup) Data..
  fetchReferenceData(){
    return this.commonService.fetchReferenceData();
  }
  //Fetch all submissions..
  fetchSubmissions(){
    return this.http.get<any>(SUBMISSION_URL.Submissions, {observe: 'response'})
    .pipe(map(response => {
      return response.body.result;
    }));    
  }


  //Validate Address
  validateAddress(addresses): Observable<HttpResponse<any>>{
    return this.newBusinessService.validateAddress(addresses);
  }

  //ClearAccount
  clearAccount(accountData): Observable<HttpResponse<any>>{
    return this.newBusinessService.clearAccount(accountData);
  }

  //Products & Underwriters
  productsUnderwriters(requestPayload){
    return this.http.post<any>(SUBMISSION_URL.ProductsUnderwriters, requestPayload, {observe: 'response'})
    .pipe(map(response => {
      console.log('All Products and Underwriters loaded');
      return response.body.result;
    }));
  }
  submitSubmission(_submission){
    return this.http.post<any>(SUBMISSION_URL.SubmitSubmission, _submission, {observe: 'response'})
    .pipe(map(response => {
      return response.body.result;
    }));
  }

  fetchSubmissionDetails(_submissionId){
    return this.http.get<any>(SUBMISSION_URL.SubmissionDetails +_submissionId, {observe: 'response'})
    .pipe(map(response => {
      console.log('submission details loaded for ' + _submissionId);
      return response.body.result;
    }));    
  }

  uploadDocuments(_documents){
    return this.newBusinessService.uploadDocuments(_documents);
  }

  /** DandB Event Log **/
  dnbEventLog(_data) {
    this.commonService.setdandbevent(_data).subscribe((data:any) => {
      console.log('Submission service :: event fired', data);
    });
    this.commonService.storeDnBEventData(_data);
  }

  getDnBEventData(){
    return this.commonService.getDnBEventData();
  }
}